import { render, staticRenderFns } from "./gzhManager.vue?vue&type=template&id=34c10598&scoped=true&"
import script from "./gzhManager.vue?vue&type=script&lang=ts&"
export * from "./gzhManager.vue?vue&type=script&lang=ts&"
import style0 from "./gzhManager.vue?vue&type=style&index=0&id=34c10598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c10598",
  null
  
)

export default component.exports